import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import createLogger from 'vuex/dist/logger';
import modules from './modules';
import './api';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store: StoreOptions<RootState> = {
  state: {
    version: process.env.VUE_APP_VERSION,
  },
  modules,
  strict: debug,
  actions: {
    reset({ commit }: any) {
      Object.keys(modules).forEach((moduleName: string) => {
        commit(`${moduleName}/RESET`);
      });
    },
  },
  plugins: debug ? [createLogger()] : [],
};

export default new Vuex.Store<RootState>(store);
